import Vue from 'vue'
import App from './App.vue'
import i18n from '@/lang'
import VModal from 'vue-js-modal'
import {faAngleLeft, faAngleRight} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
Vue.component('font-awesome-icon', FontAwesomeIcon)
import { library } from '@fortawesome/fontawesome-svg-core'
library.add(faAngleLeft, faAngleRight)

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
const VueInputMask = require('vue-inputmask').default
 
Vue.use(VueInputMask)
Vue.use(VModal)
Vue.use(BootstrapVue) 

new Vue({
    render: h => h(App),
    i18n,
    
}).$mount('#app')
